
import React, { Component, Fragment } from 'react'
import './light_bulb.css'

class LightBulb extends Component {

    render = () => {
        return (
            <Fragment>
                <div class="lightbulb">
                    <span class="ico ico-lightbulb"></span>
                    <span class="ico ico-lightbulb1"></span>
                    <span class="ico ico-lightbulb2"></span>
                    <span class="ico ico-lightbulb3"></span>
                    <span class="ico ico-lightbulb4"></span>
                </div>
            </Fragment>
        )

    }
}

export default LightBulb